"use client";

import dynamic from "next/dynamic";

const GaleriFotoDesc = dynamic(() => import("@/app/Components/Pages/GaleriFotoDescPage"), {
  ssr: false,
});

export default function GaleriFotoDescWrapper({ documentId }) {
  return <GaleriFotoDesc documentId={documentId} />;
}
